import { indexValue } from "./scripts/helper";
import "./scripts/cookie";
import "./scripts/defaults";
import "./scripts/forms";
import "./scripts/header";
import "./scripts/footer";
import "./scripts/slick";
import "./scripts/column-service";
import "./scripts/map";
import "./scripts/post";
import "./scripts/social";
import "./scripts/modal";
import "./scripts/videojs";
import "./scripts/main";
import "./scripts/search";
import "./scripts/instagram";
import "./scripts/pages/template-home-v2";

(function($) {
    $.extend(Cm, {
        o: function(propName) {
            return indexValue(Cm.defaults, propName);
        },
        init: function() {
            this.main.init();
            this.forms.init();
            this.header.init();
            this.footer.init();
            this.slick.init();
            this.columnService.init();
            this.map.init();
            this.post.init();
            this.social.init();
            this.modal.init();
            this.modal.announcement();
            this.modal.subscribe();
            this.videoplayer.init();
            this.search.init();
            this.instagram.init();
            this.modal.signup();
            this.modal.signupform();
            this.modal.appsignup();
        },
        toInt: function(value) {
            return parseInt(value);
        },
        isTrue: function(value) {
            return value === 'true' || value === '1' || value > 0 || value === 'yes' || value === true;
        }
    });

    Cm.init();    /** IG */
    igresize();
    $( window ).resize( function() {
        igresize();
    });
    function igresize() {
        var igfeedimage = $('.custom-igfeed-image');
        igfeedimage.each(function( key ) {
            var igwidth = $(this).innerWidth();
            $(this).css( "height", igwidth + "px" );
            $(this).parent().css( "height", igwidth + "px" );
        });
    }
    /** IG End */
    
    if( $('.btn-share-single').length > -1 ) {
        $('.bio-links').on('click', 'a.btn-share-single', function() {
            if (navigator.canShare && $(window).outerWidth() <= 600 ) {
                let link = $(this);
                let singleurl = link.data('singleurl');
                let singletext = link.data('singletext');

                navigator.share({
                    title: singletext,
                    text: singleurl,
                })
                .then(() => console.log('Share was successful.'))
                .catch((error) => console.log('Sharing failed', error));
            } else {
                $('.btn-share-single').attr('data-toggle', 'modal');
                let linkdetails =  $(this).data('linkdetails');
                let singleurl = $(this).data('singleurl');
                $('#share-single-modal .modal-title').html('').html( linkdetails.socmed_heading );
    
                let appendLinks = "";
                $.each(linkdetails.urls, function( k, v ){
                    let hasDisplay = 'd-block';
                    if(v.link_image === false) {
                        hasDisplay = 'd-none';
                    }
                    appendLinks += '<a target="_blank" href=" ' + v.link_url + ' " class="btn btn-outline-secondary btn-lg btn-block text-left btn-socmed">' +
                        '<img src=" ' + v.link_image + '" class="link-image ' + hasDisplay + '; ?>" /> ' +
                        v.link_text +
                        '<span class="dashicons dashicons-arrow-right-alt2 float-right"></span></a>';
                });
    
                if( appendLinks === "" ) {
                    appendLinks += '<p class="text-center">No shareable links available!</p>';
                }
    
                $('#share-single-modal .modal-body').html('').html( appendLinks );
                $('#share-single-modal .btn-modal-footer p').html('').html( singleurl );
                $('#share-single-modal .btn-modal-footer').on('click', function() {
                    navigator.clipboard.writeText(singleurl);
                });
            }

        });
    }
    /** Share Single */
    $('.btn-upload').on('click', function() {
        if (navigator.canShare && $(window).outerWidth() <= 600 ) {
            let link = $(this);
            let shareable_title = link.data('linktext');
            let shareable_url = link.data('linkurl');

            navigator.share({
            title: shareable_title,
            text: shareable_url,
            })
            .then(() => console.log('Share was successful.'))
            .catch((error) => console.log('Sharing failed', error));
        } else {
            $(this).attr('data-toggle', 'modal');
        }
    });
    /** Share Single End */
})(jQuery);
